import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { paymentFailed, payWithYandexPay } from 'src/store/payment/actions';
import { PAYMENT_ERRORS } from 'src/store/payment/constants';
import { selectYandexPayData } from 'src/store/payment/selectors';

export const YANDEX_PAY_BUTTON_SELECTOR = 'YANDEX_PAY_BUTTON';

let session = null;
let y;

export const useLazyYandexPaySdk = () => {
  const yandexData = useSelector(selectYandexPayData);
  const dispatch = useDispatch();

  const mountButton = () => {
    const mountContainer = document.getElementById(YANDEX_PAY_BUTTON_SELECTOR);
    /**
     * Добавил доп проверку на ноды, потому что видимо у нас после создания сессии
     * обработчик then отрабатывает и useEffect после анмаунта из-за рандомных ререндеров
     */
    if (!mountContainer?.hasChildNodes())
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (session as any)?.mountButton(mountContainer, {
        type: y.ButtonType.Pay,
        theme: y.ButtonTheme.WhiteOutlined,
        width: y.ButtonWidth.Max,
      });
  };

  const onError = (err) => {
    // eslint-disable-next-line no-console
    console.error('Ошибка во время оформления Yandex Pay: ', err);
    dispatch(
      paymentFailed({
        message: PAYMENT_ERRORS.YANDEX_PAY,
        techIssue: `Ошибка во время оформления Yandex Pay: ${JSON.stringify(
          err,
        )}`,
      }),
    );
  };

  const onLoad = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    y = (window as any).YaPay;

    if (!yandexData) {
      onError(new Error('Не переданы данные для Yandex Pay'));
      return;
    }

    const paymentData = {
      env: y.PaymentEnv[yandexData.env],
      version: yandexData.version,
      currencyCode: y.CurrencyCode[yandexData.currencyCode],
      merchantId: yandexData.merchantId,
      totalAmount: yandexData.paymentAmount.toString(),
      availablePaymentMethods: yandexData.availablePaymentMethods,
    };

    const onPayButtonClick = () =>
      new Promise<string>((resolve, reject) => {
        dispatch(payWithYandexPay({ resolve, reject }));
      });

    y.createSession(paymentData, {
      onPayButtonClick,
      onFormOpenError: onError,
    })
      .then((paymentSession) => {
        session = paymentSession;
        mountButton();
      })
      .catch(onError);
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((window as any).YaPay) {
      if (session) mountButton();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://pay.yandex.ru/sdk/v1/pay.js';
    script.async = true;

    script.onload = () => {
      onLoad();
    };

    script.onerror = () => {
      const message = 'Ошибка загрузки Yandex Pay SDK';
      // eslint-disable-next-line no-console
      console.error(message);
      onError(new Error(message));
    };

    document.body.appendChild(script);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
